import React, { useState } from 'react';
import styled from 'styled-components';
import BaseButton from './BaseButton';

import { Colors } from '../../../../scss/common/style';

interface Props {
  size?: 'sm' | 'lg';
  onClick?: () => void;
  title?: string;
  isSubmitting?: boolean;
  active?: boolean;
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit';
}

export default function SmallTabButton({
  onClick,
  title,
  isSubmitting = false,
  active = false,
  disabled = false,
  type,
}: Props): JSX.Element {
  return (
    <StyledButton active={active}>
      <BaseButton
        type={type}
        title={title}
        onClick={onClick}
        isSubmitting={isSubmitting}
        disabled={disabled}
        active={active}
      />
    </StyledButton>
  );
}

const StyledButton = styled.div`
  button {
    border-radius: 0;
    height: 33px;
    width: 49px !important;
    padding: 0;
    color: ${(props) => (props.active ? '#fff' : Colors.darkBrown)}!important;
    border: 1px solid ${(props) => (props.active ? Colors.darkBrown : '#EEEEEE')};
    background-color: ${(props) => (props.active ? Colors.darkBrown : '#FBFBFB')};
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      color: ${(props) => (props.active ? '#fff' : Colors.darkBrown)}!important;
      border: 1px solid ${(props) => (props.active ? Colors.darkBrown : '#EEEEEE')};
      background-color: ${(props) => (props.active ? Colors.darkBrown : '#EEEEEE')};
    }
  }
`;
